import { useLocation} from 'react-router-dom';
import React ,{useState}from 'react'
import {  Link } from "react-router-dom";
import {AiOutlineHome} from "react-icons/ai"
import {LiaBlogSolid} from "react-icons/lia"
// import {GrProjects} from "react-icons/gr"
import {SiKnowledgebase}from "react-icons/si"
import {IoAppsOutline} from "react-icons/io5"




function Navbar() {
  const [nav,setNav]=useState(null);
  let location = useLocation();

  React.useEffect(() => {
      setNav(location.pathname);
  }, [location]);  
  return (
    <>
      <nav className="navbar navbar-expand-lg bg-primary">
  <div className="container">
  
    
      <div className="navBar">
        <Link  className={`nav-link active navbar-item ${nav==="/"?"navbar-item-active":""}`} aria-current="page" to="/"><AiOutlineHome/>Home</Link>
        <Link className={`nav-link active navbar-item ${nav==="/blog"?"navbar-item-active":""}`} to="/blog"><LiaBlogSolid/>Blog</Link>
        <Link className={`nav-link active navbar-item ${nav==="/project"?"navbar-item-active":""}`} to="/project"><IoAppsOutline/>Project</Link>
        <Link className={`nav-link active navbar-item ${nav==="/skill"?"navbar-item-active":""}`} to="/skill" ><SiKnowledgebase/>Skill</Link>
      </div>
    </div>
 
</nav>
</>
  )
}

export default Navbar
